// extracted by mini-css-extract-plugin
module.exports = {"categoryTags":"CategoryTags_categoryTags__kCacl","tagLink":"CategoryTags_tagLink__nGHcT","tag":"CategoryTags_tag__x9GSa"};